import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import Switch from "@material-ui/core/Switch";
import NightsStayOutlined from "@material-ui/icons/NightsStayOutlined";
import React from "react";
import { ModoTemaContext } from "../../styles/theme/modoTema";

const ROTULO = "Tema escuro";

const ItemModoTema = () => {
  const { modo, alternarModo } = React.useContext(ModoTemaContext);
  return (
    <MenuItem onClick={alternarModo}>
      <ListItemIcon>
        <NightsStayOutlined fontSize="small" />
      </ListItemIcon>
      <ListItemText primary={ROTULO} />
      <Switch
        edge="end"
        size="small"
        color="primary"
        checked={modo === "dark"}
        onChange={alternarModo}
        onClick={(evento) => evento.stopPropagation()}
        inputProps={{ role: "switch", "aria-label": ROTULO }}
      />
    </MenuItem>
  );
};

export default ItemModoTema;
